import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Box, Tooltip } from '@mui/material';
import { CrashReportTrigger } from 'lib/gql/queryTypes';
import { FC, ReactNode } from 'react';
import { formatCrashReportTrigger } from './formatters';

interface Props {
  trigger: CrashReportTrigger;
}

const CrashReportTriggerIcon: FC<Props> = ({ trigger }) => {
  const label = formatCrashReportTrigger(trigger);
  let icon: ReactNode;

  switch (trigger) {
    case CrashReportTrigger.ProcessCrashed:
      icon = <ErrorOutlineIcon color="error" fontSize="small" />;
      break;
    case CrashReportTrigger.UserCrashed:
      icon = <BugReportOutlinedIcon color="warning" fontSize="small" />;
      break;
    case CrashReportTrigger.UserManuallyRestarted:
      icon = <RestartAltIcon color="primary" fontSize="small" />;
      break;
  }

  return (
    <Tooltip title={label}>
      <Box
        component="span"
        aria-label={label}
        tabIndex={0}
        sx={{ display: 'inline-flex', alignItems: 'center' }}
      >
        {icon}
      </Box>
    </Tooltip>
  );
};

export default CrashReportTriggerIcon;
